// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/abouttestbg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body{
  background: white !important;
}
/* About Page Styles */
.about-page {
  color: white;
  position: relative;
  overflow: hidden;
  min-height: 90vh;
}

/* Background with glowing wavy lines */
.about-background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.wavy-lines {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background: 
    radial-gradient(circle at 80% 20%, rgba(64, 156, 255, 0.1) 0%, transparent 50%),
    radial-gradient(circle at 20% 80%, rgba(64, 156, 255, 0.08) 0%, transparent 50%),
    linear-gradient(45deg, transparent 30%, rgba(64, 156, 255, 0.05) 50%, transparent 70%);
  animation: glow 8s ease-in-out infinite alternate;
}

@keyframes glow {
  0% {
    opacity: 0.3;
    transform: translateX(0) translateY(0);
  }
  100% {
    opacity: 0.6;
    transform: translateX(-10px) translateY(-10px);
  }
}

/* Main Content Styles */
.about-main {
  position: relative;
  z-index: 10;
  height: 70vh;
  display: flex;
  align-items: center;
}

.content-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  width: 100%;
}

.about-content {
  max-width: 650px;
  margin-left: 0;
}

.about-title {
  font-size: 3.5rem;
  font-weight: 700;
  color: white;
  margin-bottom: 20px;
  line-height: 1.2;
}

.about-tagline {
  font-size: 1.5rem;
  font-weight: 600;
  color: white;
  margin-top: 3rem;
  line-height: 1.4;
}

.about-description {
  font-size: 1.1rem;
  line-height: 1.7;
  color: rgba(255, 255, 255, 0.9);
  margin: 0;
}

/* What makes MAIA different section styles */
.what-makes-different-section {
  padding: 6rem 0;
  background: white;
  color: #000;
}

.what-makes-content {
  padding: 2rem 0;
}

.what-makes-title {
  font-size: 32px;
  font-weight: 700;
  color: #000;
  margin-bottom: 1.5rem;
  line-height: 1.2;
  font-family: 'Gilroy', sans-serif;
}

.what-makes-text {
  font-size: 16px;
  color: #747474;
  line-height: 1.6;
  font-family: 'Gilroy', sans-serif;
  font-weight: 400;
  margin-bottom: 1.5rem;
}

.what-makes-mission {
  font-size: 16px;
  font-weight: 700;
  color: #000;
  margin-bottom: 1rem;
  font-family: 'Gilroy', sans-serif;
}

.what-makes-mission-text {
  font-size: 16px;
  color: #747474;
  line-height: 1.6;
  font-family: 'Gilroy', sans-serif;
  font-weight: 400;
}

/* Visual elements */
.what-makes-visual {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Responsive Design */
@media (max-width: 768px) {
  .about-title {
    font-size: 2.5rem;
  }
  
  .about-tagline {
    font-size: 1.3rem;
  }
  
  .about-description {
    font-size: 1rem;
  }
  
  .about-main {
    padding-top: 80px;
  }
  
  .what-makes-title {
    font-size: 2rem;
  }
  
  .what-makes-text,
  .what-makes-mission-text {
    font-size: 1rem;
  }
  
  .what-makes-visual {
    height: 300px;
    margin-top: 2rem;
  }
  
  .chat-icons {
    gap: 15px;
  }
  
  .chat-icon {
    width: 28px;
    height: 28px;
    font-size: 12px;
  }
}

@media (max-width: 480px) {
  .about-title {
    font-size: 2rem;
  }
  
  .about-tagline {
    font-size: 1.1rem;
  }
  
  .content-container {
    padding: 0 15px;
  }
  
  .about-main {
    padding-top: 60px;
  }
  
  .what-makes-visual {
    height: 250px;
  }
  
  .chat-icons {
    gap: 10px;
  }
  
  .chat-icon {
    width: 24px;
    height: 24px;
    font-size: 10px;
  }
} 

/* Built by Clinicians and Technologists section styles */
.built-by-section {
  padding: 0;
  background: white;
  color: #000;
}

.built-by-content {
  max-width: 800px;
  margin: 0 auto;
}

.built-by-title {
  font-size: 32px;
  font-weight: 700;
  color: #000;
  margin-bottom: 1.5rem;
  line-height: 1.2;
  font-family: 'Gilroy', sans-serif;
}

.built-by-description {
  font-size: 16px;
  color: #747474;
  line-height: 1.6;
  font-family: 'Gilroy', sans-serif;
  font-weight: 400;
  margin-bottom: 3rem;
}

/* Team cards */
.team-card {
  border-radius: 20px;
  overflow: hidden;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.team-card-header {
  text-align: center;
  padding: 1rem 1rem 0.5rem 1rem;
}

.team-member-name span {
  font-weight: 400;
}

.team-member-photo {
  flex: 1 1;
  display: flex;
  justify-content: center;
}

.team-member-photo img {
  max-width: 100%;
  height: auto;
  border-radius: 15px;
}

.team-member-info {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  transition: transform 0.3s ease;
  gap: 0.5rem;
}

.team-member-info:hover {
  transform: scale(1.05);
}

.team-member-name {
  font-size: 16px;
  font-weight: 700;
  margin: 0;
  font-family: 'Gilroy', sans-serif;
}

.name-link {
  text-decoration: none;
  color: inherit;
}

.linkedin-link {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.linkedin-link svg {
  width: 20px;
  height: 20px;
}

/* Individual card styles */
.team-card-admir {
  background: linear-gradient(180deg, #0F4ABE 0%, #0038A6 100%);
}

.team-card-admir .team-member-name {
  color: white;
}

.team-card-admir .linkedin-link svg {
  fill: white;
}

.team-card-charles {
  background: linear-gradient(360deg, #F7F7F7 0%, #FFFFFF 100%);
  border: 2px solid #F5F5F5
}

.team-card-charles .team-member-name {
  color: #0F4ABE;
}

.team-card-sabina {
  background: linear-gradient(360deg, #F7F7F7 0%, #FFFFFF 100%);
  border: 2px solid #F5F5F5
}

.team-card-sabina .team-member-name {
  color: #0F4ABE;
}

.bgblue {
  background-color: #fff;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
}

.bgbluecard {
  background-color: #fff !important;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .built-by-title {
    font-size: 28px;
  }
  
  .built-by-description {
    font-size: 14px;
  }
  
  .team-member-name {
    font-size: 16px;
  }
  
  .team-card-header {
    padding: 1rem 1rem 0.5rem 1rem;
  }
  
  .team-member-photo {
    padding: 0 0.5rem 1rem 0.5rem;
  }
}

@media (max-width: 480px) {
  .built-by-title {
    font-size: 24px;
  }
  
  .built-by-description {
    font-size: 13px;
  }
  
  .team-member-name {
    font-size: 14px;
  }
}

.bgblue{
  margin-bottom: 0 !important;
}

/* Testimonials Disclaimer */
.testimonials-disclaimer {
  text-align: center;
  background: #fff;
  color: #AFAFAF;
  padding: 2rem 0;
  font-family: 'Gilroy', sans-serif;
  font-size: 16px;
  line-height: 1.6;
  font-weight: 400;
} `, "",{"version":3,"sources":["webpack://./src/components/About/About.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;AAC9B;AACA,sBAAsB;AACtB;EACE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,uCAAuC;AACvC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,WAAW;EACX,YAAY;EACZ;;;0FAGwF;EACxF,iDAAiD;AACnD;;AAEA;EACE;IACE,YAAY;IACZ,sCAAsC;EACxC;EACA;IACE,YAAY;IACZ,8CAA8C;EAChD;AACF;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,+BAA+B;EAC/B,SAAS;AACX;;AAEA,6CAA6C;AAC7C;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,qBAAqB;EACrB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,iCAAiC;EACjC,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,sBAAsB;AACtB;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;AACF;;AAEA,yDAAyD;AACzD;EACE,UAAU;EACV,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,qBAAqB;EACrB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,iCAAiC;EACjC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,mBAAmB;EACnB,gBAAgB;EAChB,qDAAqD;EACrD,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,+BAA+B;EAC/B,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,iCAAiC;AACnC;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,2BAA2B;AAC3B;EACE,6DAA6D;AAC/D;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,6DAA6D;EAC7D;AACF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D;AACF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,yDAAgD;EAChD,wBAAwB;EACxB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,iCAAiC;AACnC;;AAEA,2BAA2B;AAC3B;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB","sourcesContent":["body{\n  background: white !important;\n}\n/* About Page Styles */\n.about-page {\n  color: white;\n  position: relative;\n  overflow: hidden;\n  min-height: 90vh;\n}\n\n/* Background with glowing wavy lines */\n.about-background {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n}\n\n.wavy-lines {\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  width: 100%;\n  height: 100%;\n  background: \n    radial-gradient(circle at 80% 20%, rgba(64, 156, 255, 0.1) 0%, transparent 50%),\n    radial-gradient(circle at 20% 80%, rgba(64, 156, 255, 0.08) 0%, transparent 50%),\n    linear-gradient(45deg, transparent 30%, rgba(64, 156, 255, 0.05) 50%, transparent 70%);\n  animation: glow 8s ease-in-out infinite alternate;\n}\n\n@keyframes glow {\n  0% {\n    opacity: 0.3;\n    transform: translateX(0) translateY(0);\n  }\n  100% {\n    opacity: 0.6;\n    transform: translateX(-10px) translateY(-10px);\n  }\n}\n\n/* Main Content Styles */\n.about-main {\n  position: relative;\n  z-index: 10;\n  height: 70vh;\n  display: flex;\n  align-items: center;\n}\n\n.content-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 20px;\n  width: 100%;\n}\n\n.about-content {\n  max-width: 650px;\n  margin-left: 0;\n}\n\n.about-title {\n  font-size: 3.5rem;\n  font-weight: 700;\n  color: white;\n  margin-bottom: 20px;\n  line-height: 1.2;\n}\n\n.about-tagline {\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: white;\n  margin-top: 3rem;\n  line-height: 1.4;\n}\n\n.about-description {\n  font-size: 1.1rem;\n  line-height: 1.7;\n  color: rgba(255, 255, 255, 0.9);\n  margin: 0;\n}\n\n/* What makes MAIA different section styles */\n.what-makes-different-section {\n  padding: 6rem 0;\n  background: white;\n  color: #000;\n}\n\n.what-makes-content {\n  padding: 2rem 0;\n}\n\n.what-makes-title {\n  font-size: 32px;\n  font-weight: 700;\n  color: #000;\n  margin-bottom: 1.5rem;\n  line-height: 1.2;\n  font-family: 'Gilroy', sans-serif;\n}\n\n.what-makes-text {\n  font-size: 16px;\n  color: #747474;\n  line-height: 1.6;\n  font-family: 'Gilroy', sans-serif;\n  font-weight: 400;\n  margin-bottom: 1.5rem;\n}\n\n.what-makes-mission {\n  font-size: 16px;\n  font-weight: 700;\n  color: #000;\n  margin-bottom: 1rem;\n  font-family: 'Gilroy', sans-serif;\n}\n\n.what-makes-mission-text {\n  font-size: 16px;\n  color: #747474;\n  line-height: 1.6;\n  font-family: 'Gilroy', sans-serif;\n  font-weight: 400;\n}\n\n/* Visual elements */\n.what-makes-visual {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .about-title {\n    font-size: 2.5rem;\n  }\n  \n  .about-tagline {\n    font-size: 1.3rem;\n  }\n  \n  .about-description {\n    font-size: 1rem;\n  }\n  \n  .about-main {\n    padding-top: 80px;\n  }\n  \n  .what-makes-title {\n    font-size: 2rem;\n  }\n  \n  .what-makes-text,\n  .what-makes-mission-text {\n    font-size: 1rem;\n  }\n  \n  .what-makes-visual {\n    height: 300px;\n    margin-top: 2rem;\n  }\n  \n  .chat-icons {\n    gap: 15px;\n  }\n  \n  .chat-icon {\n    width: 28px;\n    height: 28px;\n    font-size: 12px;\n  }\n}\n\n@media (max-width: 480px) {\n  .about-title {\n    font-size: 2rem;\n  }\n  \n  .about-tagline {\n    font-size: 1.1rem;\n  }\n  \n  .content-container {\n    padding: 0 15px;\n  }\n  \n  .about-main {\n    padding-top: 60px;\n  }\n  \n  .what-makes-visual {\n    height: 250px;\n  }\n  \n  .chat-icons {\n    gap: 10px;\n  }\n  \n  .chat-icon {\n    width: 24px;\n    height: 24px;\n    font-size: 10px;\n  }\n} \n\n/* Built by Clinicians and Technologists section styles */\n.built-by-section {\n  padding: 0;\n  background: white;\n  color: #000;\n}\n\n.built-by-content {\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n.built-by-title {\n  font-size: 32px;\n  font-weight: 700;\n  color: #000;\n  margin-bottom: 1.5rem;\n  line-height: 1.2;\n  font-family: 'Gilroy', sans-serif;\n}\n\n.built-by-description {\n  font-size: 16px;\n  color: #747474;\n  line-height: 1.6;\n  font-family: 'Gilroy', sans-serif;\n  font-weight: 400;\n  margin-bottom: 3rem;\n}\n\n/* Team cards */\n.team-card {\n  border-radius: 20px;\n  overflow: hidden;\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.team-card-header {\n  text-align: center;\n  padding: 1rem 1rem 0.5rem 1rem;\n}\n\n.team-member-name span {\n  font-weight: 400;\n}\n\n.team-member-photo {\n  flex: 1;\n  display: flex;\n  justify-content: center;\n}\n\n.team-member-photo img {\n  max-width: 100%;\n  height: auto;\n  border-radius: 15px;\n}\n\n.team-member-info {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1rem;\n  transition: transform 0.3s ease;\n  gap: 0.5rem;\n}\n\n.team-member-info:hover {\n  transform: scale(1.05);\n}\n\n.team-member-name {\n  font-size: 16px;\n  font-weight: 700;\n  margin: 0;\n  font-family: 'Gilroy', sans-serif;\n}\n\n.name-link {\n  text-decoration: none;\n  color: inherit;\n}\n\n.linkedin-link {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.linkedin-link svg {\n  width: 20px;\n  height: 20px;\n}\n\n/* Individual card styles */\n.team-card-admir {\n  background: linear-gradient(180deg, #0F4ABE 0%, #0038A6 100%);\n}\n\n.team-card-admir .team-member-name {\n  color: white;\n}\n\n.team-card-admir .linkedin-link svg {\n  fill: white;\n}\n\n.team-card-charles {\n  background: linear-gradient(360deg, #F7F7F7 0%, #FFFFFF 100%);\n  border: 2px solid #F5F5F5\n}\n\n.team-card-charles .team-member-name {\n  color: #0F4ABE;\n}\n\n.team-card-sabina {\n  background: linear-gradient(360deg, #F7F7F7 0%, #FFFFFF 100%);\n  border: 2px solid #F5F5F5\n}\n\n.team-card-sabina .team-member-name {\n  color: #0F4ABE;\n}\n\n.bgblue {\n  background-color: #fff;\n  background-image: url(\"/public/abouttestbg.png\");\n  background-size: contain;\n  background-position: center;\n  background-repeat: no-repeat;\n}\n\n.bgbluecard {\n  background-color: #fff !important;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .built-by-title {\n    font-size: 28px;\n  }\n  \n  .built-by-description {\n    font-size: 14px;\n  }\n  \n  .team-member-name {\n    font-size: 16px;\n  }\n  \n  .team-card-header {\n    padding: 1rem 1rem 0.5rem 1rem;\n  }\n  \n  .team-member-photo {\n    padding: 0 0.5rem 1rem 0.5rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .built-by-title {\n    font-size: 24px;\n  }\n  \n  .built-by-description {\n    font-size: 13px;\n  }\n  \n  .team-member-name {\n    font-size: 14px;\n  }\n}\n\n.bgblue{\n  margin-bottom: 0 !important;\n}\n\n/* Testimonials Disclaimer */\n.testimonials-disclaimer {\n  text-align: center;\n  background: #fff;\n  color: #AFAFAF;\n  padding: 2rem 0;\n  font-family: 'Gilroy', sans-serif;\n  font-size: 16px;\n  line-height: 1.6;\n  font-weight: 400;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
